import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import Login from './views/Login';

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: true
      },
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
});

router.beforeEach((to, from, next) => {
  if( to.matched.some(record => record.meta.requiresAuth) ) {
    if(to.query.t !== 'SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'){
      next({
        path: '/login',
      });
    } else {
      next();
    }
  } else { next(); }
});

export default router;